webpackJsonp([262017805209049],{

/***/ 447:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"id":"/opt/build/repo/src/pages/articles/07-Living-with/01-webmd-living-with.md absPath of file >>> MarkdownRemark","frontmatter":{"path":"webmd-living-with","title":"Living with hepatitis C (WebMD)","category":"living-with","categoryDesc":"Living with","source":"WebMD"}}},{"node":{"id":"/opt/build/repo/src/pages/articles/07-Living-with/02-nhs-living-with.md absPath of file >>> MarkdownRemark","frontmatter":{"path":"nhs-living-with","title":"Lifestyle FAQs (NHS)","category":"living-with","categoryDesc":"Living with","source":"NHS"}}},{"node":{"id":"/opt/build/repo/src/pages/articles/07-Living-with/03-emedicinehealth-living-with.md absPath of file >>> MarkdownRemark","frontmatter":{"path":"emedicinehealth-living-with","title":"Living with hepatitis C (emedicinehealth)","category":"living-with","categoryDesc":"Living with","source":"emedicinehealth"}}}]}},"pathContext":{"category":"living-with"}}

/***/ })

});


// WEBPACK FOOTER //
// path---category-living-with-10eed3407673bef96d85.js